import React from 'react';
import { CellContext } from '@tanstack/react-table';

import { AdaptiveTableCell } from '@components/common';

export const getColumns = (date?: string) => ([
	{
		header: date ? `Date (${date})` : 'Date',
		accessorKey: 'date',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const paramName = getValue();

			return <AdaptiveTableCell text={paramName} />;
		},
	},
	{
		header: 'Value',
		accessorKey: 'value',
		enableSorting: false,
		cell: ({ getValue }: CellContext<any, any>) => {
			const siteId = getValue();

			return <AdaptiveTableCell text={siteId} />;
		},
	},
]);
